"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appLayoutDefaultProps = exports.APPLAYOUT_SIDENAV_WIDTH = exports.APPLAYOUT_MAIN_MEDIUM_SPACING = exports.APPLAYOUT_HEADER_XL_SPACING = exports.APPLAYOUT_CONTENT_SPACING_GAP = exports.APPLAYOUT_CONTENT_SPACING = void 0;
var _interfaces = require("../../page/page-header/interfaces");
const APPLAYOUT_HEADER_XL_SPACING = exports.APPLAYOUT_HEADER_XL_SPACING = 32;
const APPLAYOUT_MAIN_MEDIUM_SPACING = exports.APPLAYOUT_MAIN_MEDIUM_SPACING = 190;
const APPLAYOUT_CONTENT_SPACING = exports.APPLAYOUT_CONTENT_SPACING = {
  xl: 80,
  lg: 32,
  md: 24,
  sm: 16
};
const APPLAYOUT_CONTENT_SPACING_GAP = exports.APPLAYOUT_CONTENT_SPACING_GAP = {
  lg: 32,
  md: 24,
  sm: 16
};
const APPLAYOUT_SIDENAV_WIDTH = exports.APPLAYOUT_SIDENAV_WIDTH = 405;
const appLayoutDefaultProps = exports.appLayoutDefaultProps = {
  isHeaderFixed: true,
  colorScheme: _interfaces.PageHeaderColorScheme.Inverted
};